const paymentHr = {
    "billing": {
        "name": "Ime/Naziv tvrtke",
        "country": "Zemlja",
        "postal_code": "Poštanski broj",
        "city": "Grad",
        "address": "Adresa",
        "tax_number": "Porezni broj",
        "phone": "Broj telefona",
        "tax_number_helper_text": "Obavezno za tvrtke, nije obavezno za pojedince",
        "billing_info": "Podaci o naplati",
        "emails_helper_text": "Neobavezno. Za više adresa e-pošte, odvojite ih zarezima."
    },
    "subscription_plans": {
        "PRO": "Pro plan",
        "FREE": "Besplatni plan"
    },
    "plan_descriptions": {
        "PRO": "Za restorane koji žele podići svoje poslovanje na višu razinu! Prevedite svoj jelovnik na nove jezike uz samo nekoliko klikova, zatražite povratne informacije od gostiju o njihovim jelima, pratite korištenje jelovnika s QR kodom pomoću korisnih statistika ili dopustite da QuickPick AI automatski odgovori na povratne informacije vaših gostiju u vašem stilu!",
        "FREE": "Za restorane koji žele započeti s online jelovnikom i QR kodovima."
    },
    "subscription_status": {
        "ACTIVE": "Aktivan",
        "CANCELLED": "Otkazano"
    },
    "next_billing_date": "Sljedeći datum naplate",
    "current_subscription": "Trenutna pretplata",
    "cancel": "Otkazati",
    "subscription_interval_prices": {
        "MONTHLY": "mjesec",
        "YEARLY": "godina",
        "HALF_YEARLY": "pola godine",
        "QUARTERLY": "četvrt"
    },
    "subscription_interval_payment_name": {
        "MONTHLY": "Mjesečna pretplata",
        "YEARLY": "Godišnja pretplata",
        "HALF_YEARLY": "Polugodišnja pretplata",
        "QUARTERLY": "Tromjesečna pretplata"
    },
    "reactivate": "Ponovno aktiviraj",
    "valid_to": "Vrijedi do",
    "payments_and_invoices": "Plaćanja i fakture",
    "amount": "Iznositi",
    "invoice": "Dostavnica",
    "update_card": "Ažurirati",
    "payment_method": "Način plaćanja",
    "cancel_subscription_confirmation": "Jeste li sigurni da želite otkazati svoju trenutnu pretplatu?",
    "cancel_subscription_valid_until": "Pretplata će ostati važeća do sljedećeg datuma",
    "subscription_cancelled": "Pretplata je uspješno otkazana",
    "reactivate_confirmation": "Jeste li sigurni da želite ponovno aktivirati otkazanu pretplatu?",
    "reactivate_successful": "Pretplata je uspješno ponovno aktivirana",
    "change_payment_method": "Promjena načina plaćanja",
    "change_payment_method_tooltip": "Da biste promijenili podatke o plaćanju, morate platiti za sljedeće razdoblje pretplate. Naravno, vaša će se pretplata produžiti za duljinu razdoblja, a sljedeći datum naplate dospijeva za isti vremenski period.",
    "amount_to_be_paid": "Iznos za plaćanje",
    "new_subscription_valid_until": "Nova valjanost pretplate",
    "bank_card_expires_soon": "Bankovna kartica korištena za pretplatu uskoro će isteći.",
    "reactivate_subscription_confirmation": "Jeste li sigurni da želite ponovno aktivirati otkazanu pretplatu?",
    "billing_information": "Podaci o naplati",
    "edit_billing_information": "Uredi podatke o naplati",
    "no_available_invoices": "Nema dostupnih faktura",
    "subscribe": "Pretplatite se",
    "continue_to_payment": "Nastavite s plaćanjem",
    "confirm_subscription": "Potvrdi pretplatu",
    "subscription_page_title": "Započni pretplatu",
    "pay": "Plaćanje",
    "available_plans": "Dostupna pretplata",
    "accept_terms_and_conditions": "Pročitao/la sam i prihvaćam <a>Uvjete i odredbe</a>",
    "accept_recurring_payments": "Plaćanjem prihvaćam automatsko naplaćivanje ponavljajućih plaćanja, koje mogu otkazati u bilo kojem trenutku.",
    "accept_privacy_policy": "Pročitao/la sam i prihvaćam <a>Pravila o privatnosti</a>",
    "subscribe_soon": "Uskoro"
};

export default paymentHr;
